<div>
  @if (url) {
    <div #imageWrapper>
      @if (sizeAvailable) {
        <img height="{{ height }}" src="{{ url }}" width="{{ width }}" />
      }
      @if (!sizeAvailable) {
        <img src="{{ url }}" />
      }
    </div>
  }
</div>
